import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearUser, setUser } from "../../features/authSlice";
import { useNavigate } from "react-router-dom";
import { pb } from "../../api/pocketbase";

const usePocketBaseAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!pb.authStore.token
  );

  useEffect(() => {
    // Listen to auth state changes
    pb.authStore.onChange(() => {
      setIsAuthenticated(!!pb.authStore.token);
    });

    // Cleanup listener on unmount
    return () => {
      pb.authStore.onChange(null);
    };
  }, []);

  // const login = async (email, password) => {
  //   const authData = await pb.collection("Contacts").authWithPassword(email, password);
  //   setIsAuthenticated(!!pb.authStore.token);
  //   dispatch(setUser(authData.record));
  //   return authData;
  // };
  const login = async (email, password) => {
    try {
      const authData = await pb.collection("Contacts").authWithPassword(email, password);
      setIsAuthenticated(!!pb.authStore.token);
      return authData.record;
    } catch (error) {
      console.error("Login error:::", error);
      throw new Error(error.message || "Login failed"); 
    }
  };

  const logout = () => {
    pb.authStore.clear();
    dispatch(clearUser());
    setIsAuthenticated(false);
    navigate("/");
  };

  return {
    isAuthenticated,
    login,
    logout,
  };
};

export default usePocketBaseAuth;
